import { IRootState } from '../../../store'
import { IBodySurveyOptions } from '../store/options.types'

export const getBodySurveyOptionsSelector = (state: IRootState): IBodySurveyOptions => state.options.bodySurveyOptions
